import { Paper, Stack, Typography, Divider, Box, Tooltip, FormControlLabel, Checkbox, Button } from '@mui/material'
import ClearIcon from '@mui/icons-material/Clear'
import { alpha } from '@mui/material'
import { TempTextInput } from '../../../Component/Input/TempTextInput'
import Iconify from '../../../Component/common/iconify/Iconify'
import { chipRender } from '../constants'
import { getString } from '../../../helper/util'
import { constants } from '../../../Constants/constants'

export default function DeviceVersionList({ rawData, resource, lang, theme, deleteMode, inputError, helperTextStylesClasses, onChangeVersionConfigList, handleFolderMap, handleOnClickDrawer }) {
  const groupData = (data) =>
    data.reduce((acc, item) => {
      const { deviceType } = item
      if (!acc[deviceType]) acc[deviceType] = []
      acc[deviceType].push(item)
      return acc
    }, {})

  const groupedData = groupData(rawData)

  return (
    <Stack spacing={4} sx={{ mt: 2 }}>
      {Object.entries(groupedData).map(([deviceType, targets]) => (
        <Paper key={deviceType} variant="outlined" sx={{ p: 2 }}>
          <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={1}>
            <Typography variant="h5" color="primary" gutterBottom>
              {deviceType.toUpperCase()}
            </Typography>
            <Button
              variant="contained"
              color="error"
              startIcon={<ClearIcon />}
              onClick={() => handleFolderMap(deviceType, false)}
            >
              {getString(lang, resource, 'remove', theme)}
            </Button>
          </Stack>

          <Divider sx={{ mb: 2 }} />

          <Box sx={{ display: 'flex', gap: 3, flexWrap: 'wrap' }}>
            {targets.map((target, index) => (
              <Tooltip key={`${deviceType}-${target?.buildTarget}-${index}`} title={getString(lang, '', target?.buildTarget, theme)} placement="top" arrow>
                <Box
                  sx={{
                    flex: 1,
                    p: 2,
                    bgcolor: (theme) => alpha(theme.palette[chipRender(target?.buildTarget)?.color || 'primary'].main, 0.1),
                    borderRadius: 1,
                  }}
                >
                  <TempTextInput
                    inputSetting={{
                      className: 'edit-create-input w-100',
                      size: constants.SIZE.SMALL,
                      label: { resource, key: 'buildTarget' },
                      value: target?.buildTarget,
                      name: 'buildTarget',
                      isEndOfLine: false,
                      readOnly: true,
                      startAdornment: <Iconify icon={chipRender(target?.buildTarget)?.icon} />,
                    }}
                    handleChange={onChangeVersionConfigList}
                  />

                  {deleteMode ? (
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={target?.status}
                          onChange={(e) => onChangeVersionConfigList('status', e.target.checked, target)}
                        />
                      }
                      label={getString(lang, resource, 'delete', theme)}
                      labelPlacement="start"
                    />
                  ) : (
                    <>
                      <TempTextInput
                        inputSetting={{
                          className: 'edit-create-input w-100',
                          size: constants.SIZE.SMALL,
                          label: { resource, key: 'shopAppReleaseId' },
                          value: target?.shopAppReleaseId?.appVersion || target?.shopAppRelease?.appVersion || target?.shopAppRelease?.id,
                          onClickEndAdornmentIconButton: (e) => handleOnClickDrawer(e, 'appVersion', target),
                          name: 'shopAppReleaseId',
                          isEndOfLine: false,
                          readOnly: true,
                          disabledOnClickInputField: (e) => handleOnClickDrawer(e, 'appVersion', target),
                          helperTextIcon: true,
                          helperText: inputError['shopAppReleaseId'],
                          FormHelperTextProps: { className: helperTextStylesClasses.root },
                          clear: true,
                        }}
                        index={target}
                        handleChange={onChangeVersionConfigList}
                      />
                      <Typography variant="body2" sx={{ my: 1 }}>
                        <Typography variant="body2" component="span" color="text.secondary">Status: </Typography>
                        {target?.shopAppReleaseId?.release?.status || target?.shopAppRelease?.status}
                      </Typography>
                      <Typography variant="body2" sx={{ my: 1 }}>
                        <Typography variant="body2" component="span" color="text.secondary">Build Number: </Typography>
                        {target?.shopAppReleaseId?.buildNumber || target?.shopAppRelease?.buildNumber}
                      </Typography>
                      <Typography variant="body2" sx={{ my: 1 }}>
                        <Typography variant="body2" component="span" color="text.secondary">Custom Code: </Typography>
                        {target?.shopAppReleaseId?.customCode ?? target?.shopAppRelease?.customCode ?? '-'}
                      </Typography>
                      <FormControlLabel
                        sx={{ margin: 0 }}
                        control={
                          <Checkbox
                            checked={target?.forceUpdate}
                            onChange={(e) => onChangeVersionConfigList('forceUpdate', e.target.checked, target)}
                          />
                        }
                        label={getString(lang, resource, 'forceUpdate', theme)}
                        labelPlacement="start"
                      />
                    </>
                  )}
                </Box>
              </Tooltip>
            ))}
          </Box>
        </Paper>
      ))}
    </Stack>
  )
}